import { useMemo } from "react"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"

/**
 * Custom hook to extract and memoize booking-related data from Redux
 */
export const useBookingData = () => {
    const trip = useSelector(modelSelector("trip"))
    const booking = useSelector(modelSelector("booking"))
    console.log(booking.total_amount,'bookingdataaa')
    const bookingData = useMemo(
        () => ({
            trip,
            booking,
            guide: trip.guide,
            paymentSummary: booking.payment_summary,
            paymentHistory: booking.payment_history,
            paymentMethod:booking.payment_method,
            totalAmount:booking.total_amount,
            paymentDetails: booking.payment_summary,
            totalPrice: booking.payment_summary?.total_price,
            childCount: booking.child_count,
            hasWaivers: booking.has_waivers,
            paymentStatus: booking.payment_status,
        }),
        [trip, booking]
    )

    return bookingData
}
